import { gql } from '@apollo/client';

export const contractsGql = gql`
  query contracts(
    $parkingId: String
    $motoristId: String
    $freeflagId: String
    $order: String
    $isMotoristIn: Boolean
    $isActive: Boolean
    $categories: [String]
    $page: Int
    $limit: Int
    $isNotInPeriod: [String!]
  ) {
    contracts(
      parkingId: $parkingId
      motoristId: $motoristId
      freeflagId: $freeflagId
      order: $order
      isActive: $isActive
      isMotoristIn: $isMotoristIn
      categories: $categories
      page: $page
      limit: $limit
      isNotInPeriod: $isNotInPeriod
    ) {
      list {
        _id
        ospContractId
        isEnabled
        productId
        name1
        name2
        contractCount
        spacesAllocated
        shortUid
        gender
        presenceCounter
        stopDate
        lang
        motoristId
        address {
        address1
        address2
        zipcode
        city
        country
        }
        username
        startDate
        parkingId
        category
        isInside
        motoristId
        spacesOccupied
        credentials {
          _id
          type
          provider
          value
          description
        }
        articleCode
        freeflag {
          _id
        }
      }
      paging {
        current
        count
        limit
      }
    }
  }
`;
